import { ThemeSettingResponse } from '@magnetar/admin-api-interfaces'
import { useGet } from './useFetch'
import { useAuth } from './useAuth'

interface UseThemeSettingParams {
  broadcastDeviceId: number | string
}

export function useThemeSetting({ broadcastDeviceId }: UseThemeSettingParams) {
  const { token } = useAuth()
  const { data, error, mutate } = useGet<ThemeSettingResponse>(
    token ? `/api/broadcast-device/${broadcastDeviceId}/theme_setting` : null,
    undefined,
    token ?? '',
  )

  return {
    themeSetting: data?.data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  }
}
